module.exports = __webpack_public_path__ + "img/phone-pause.b8aa1de5.svg";